<div class="tabs-container padding-bottom">
  <tabs (tabClicked)="onTabClicked($event)">
    <tab title="Pending Payments">
      <ag-grid-angular class="data-grid " [gridOptions]="gridOptions" [rowData]="data | async" [attr.aria-label]="widgetTitle + ' - Pending Payments'"></ag-grid-angular>
    </tab>
    @if (showPendingAdjustments) {
      <tab title="Pending Adjustments">
        <ag-grid-angular class="data-grid " [gridOptions]="adjustmentGridOptions" [rowData]="adjustmentData | async" [groupDefaultExpanded]="-1" [attr.aria-label]="widgetTitle + ' - Pending Adjustments'"></ag-grid-angular>
      </tab>
    }
  </tabs>
</div>
